module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-group"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Live Class'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Live Class")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n            Daftar Live Class\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text mr-2",
    attrs: {
      "text": "",
      "id": "live_class_tambah"
    },
    on: {
      "click": function($event) {
        return _vm.reportLiveClass()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chart-bell-curve")]), _vm._v("\n                Lihat Laporan\n            ")], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "blew",
            "dark": "",
            "depressed": ""
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-dots-vertical")]), _vm._v("\n                        Live Class\n                    ")], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-list', [_c('v-list-item', {
    on: {
      "click": function($event) {
        return _vm.createliveClass()
      }
    }
  }, [_c('v-list-item-title', {
    staticClass: "blew--text font-weight-500"
  }, [_vm._v("\n                            Add New\n                        ")])], 1), _vm._v(" "), _c('v-list-item', {
    on: {
      "click": function($event) {
        _vm.dialogUploadLiveClass = true
      }
    }
  }, [_c('v-list-item-title', {
    staticClass: "blew--text font-weight-500"
  }, [_vm._v("\n                            Upload Files\n                        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.liveClasses,
      "headers": _vm.headers,
      "hasMultiSearch": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "has-action": true,
      "hasOpenNewTab": true,
      "custom-pagination-total-items": _vm.total_data,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.total_pages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "customWidth": true
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editliveClass()
      },
      "deleteOnFilter": function($event) {
        return _vm.delByOneFilter($event)
      },
      "deleted": function($event) {
        _vm.dialogConfirm.function = $event;
        _vm.dialogConfirm.title = 'Hapus Live Class';
        _vm.dialogConfirm.subtitle =
          'Apakah anda yakin akan menghapus Live Class ini?';
        _vm.dialogConfirm.open = true;
      },
      "doSearch": function($event) {
        _vm.filters = $event;
        _vm.doFilter();
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "openNewTab": function($event) {
        return _vm.openNewTab($event)
      }
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "450"
    },
    model: {
      value: (_vm.dialogConfirm.open),
      callback: function($$v) {
        _vm.$set(_vm.dialogConfirm, "open", $$v)
      },
      expression: "dialogConfirm.open"
    }
  }, [_c('dialog-confirm', {
    attrs: {
      "title": _vm.dialogConfirm.title,
      "subtitle": _vm.dialogConfirm.subtitle
    },
    on: {
      "close": function($event) {
        _vm.dialogConfirm.open = false
      },
      "confirm": function($event) {
        _vm.deleteliveClass(_vm.dialogConfirm.function);
        _vm.dialogConfirm.open = false;
      }
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "410px"
    },
    model: {
      value: (_vm.dialogSucessUpload),
      callback: function($$v) {
        _vm.dialogSucessUpload = $$v
      },
      expression: "dialogSucessUpload"
    }
  }, [_c('dialog-success-upload', {
    attrs: {
      "live-class-total": _vm.liveClassData.length,
      "live-class-total-error-excel": _vm.liveClassTotalErrorExcel
    },
    on: {
      "finish": function($event) {
        return _vm.finishUpload()
      },
      "edit": function($event) {
        _vm.dialogSucessUpload = false;
        _vm.dialogExcelError = true;
      }
    }
  })], 1), _vm._v(" "), (_vm.dialogUploadLiveClass) ? _c('app-upload-liveclass', {
    on: {
      "closeDialog": function($event) {
        _vm.dialogUploadLiveClass = false
      },
      "uploadProcess": function($event) {
        return _vm.uploadRowValidation($event)
      },
      "successUploadExcel": _vm.successUploadExcel
    }
  }) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "360"
    },
    model: {
      value: (_vm.dialogExcelValidation),
      callback: function($$v) {
        _vm.dialogExcelValidation = $$v
      },
      expression: "dialogExcelValidation"
    }
  }, [_c('dialog-upload-validation', {
    attrs: {
      "live-class-total": _vm.liveClassData.length,
      "live-class-total-check-row": _vm.liveClassTotalCheckRow
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "scrollable": "",
      "max-width": "870"
    },
    model: {
      value: (_vm.dialogExcelError),
      callback: function($$v) {
        _vm.dialogExcelError = $$v
      },
      expression: "dialogExcelError"
    }
  }, [_c('dialog-excel-error-upload', {
    attrs: {
      "live-class-total-error-excel": _vm.liveClassTotalErrorExcel,
      "live-class-data": _vm.liveClassData,
      "live-class-excel-error": _vm.liveClassExcelError,
      "type-error": _vm.type_error
    },
    on: {
      "close": function($event) {
        return _vm.finishUpload()
      }
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "370"
    },
    model: {
      value: (_vm.dialogLoadingUpload),
      callback: function($$v) {
        _vm.dialogLoadingUpload = $$v
      },
      expression: "dialogLoadingUpload"
    }
  }, [_c('dialog-upload-progress', {
    attrs: {
      "live-class-total": _vm.liveClassData.length,
      "live-class-total-check-row": _vm.liveClassTotalCheckRow,
      "progress-upload-presentation": _vm.progressUploadPresentation
    }
  })], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "330px"
    },
    model: {
      value: (_vm.dialogConfirmErrorUpload),
      callback: function($$v) {
        _vm.dialogConfirmErrorUpload = $$v
      },
      expression: "dialogConfirmErrorUpload"
    }
  }, [_c('dialog-confirm-session', {
    on: {
      "close": function($event) {
        return _vm.clearSessionErrorUpload()
      },
      "confirm": function($event) {
        return _vm.getSessionErrorUpload()
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e6cd1ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/live_class/components/LiveClass.vue
// module id = 1690
// module chunks = 1